// Shared by React, the static HTML build, and the generated edge metadata.
import seo from './seo-routes.json';
import content from './search-content.json';
import servicePages from './service-pages.json';
const ORIGIN = seo.siteOrigin;
const ORG_ID = `${ORIGIN}/#organization`;
const AREA = [{ '@type': 'State', name: 'Florida' }, { '@type': 'Country', name: 'United States' }];
const ORG = { legalName: 'ForgedOps LLC', name: seo.siteName, url: ORIGIN,
  logo: `${ORIGIN}/media/forgedops_full-768.webp`, description: content.organizationDescription };

function organizationSchema() {
  return { '@context': 'https://schema.org', '@type': 'Organization', '@id': ORG_ID,
    ...ORG, sameAs: ['https://www.linkedin.com/company/forgedopshq/'],
    contactPoint: { '@type': 'ContactPoint', telephone: '+19042978419', email: 'info@forgedopshq.com', contactType: 'Sales and Support', areaServed: 'US' } };
}
function websiteSchema() {
  return { '@context': 'https://schema.org', '@type': 'WebSite', '@id': `${ORIGIN}/#website`,
    name: seo.siteName, url: ORIGIN, description: seo.routes['/'].description,
    publisher: { '@id': ORG_ID }, inLanguage: 'en-US' };
}
function serviceSchema(def) {
  return { '@context': 'https://schema.org', '@type': 'Service', name: def.name,
    description: def.description, serviceType: def.serviceType, url: def.url || `${ORIGIN}/${def.slug}`,
    provider: { '@id': ORG_ID }, areaServed: AREA, ...(def.image ? { image: def.image } : {}) };
}
function localBusinessSchema() {
  return { '@context': 'https://schema.org', '@type': 'ProfessionalService', '@id': `${ORIGIN}/#localbusiness`,
    ...ORG, telephone: '+19042978419', email: 'info@forgedopshq.com', areaServed: AREA,
    address: { '@type': 'PostalAddress', addressRegion: 'FL', addressCountry: 'US' },
    hasOfferCatalog: { '@type': 'OfferCatalog', name: 'ForgedOps Software and Services',
      itemListElement: content.servicePillars.map(def => ({ '@type': 'Offer',
        url: `${ORIGIN}/${def.slug}`, itemOffered: serviceSchema(def) })) } };
}
function breadcrumbSchema(pathname) {
  const items = [{ '@type': 'ListItem', position: 1, name: 'Home', item: `${ORIGIN}/` }];
  const parts = pathname.split('/').filter(Boolean);
  parts.forEach((part, i) => {
    const path = '/' + parts.slice(0, i + 1).join('/');
    const title = seo.routes[path]?.title?.split(' | ')[0] || part.replace(/-/g, ' ');
    items.push({ '@type': 'ListItem', position: i + 2, name: title, item: ORIGIN + path });
  });
  return { '@context': 'https://schema.org', '@type': 'BreadcrumbList', itemListElement: items };
}
function faqPageSchema(items) {
  return { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: items.map(item => {
    const question = Array.isArray(item) ? item[0] : item.question;
    const answer = Array.isArray(item) ? item[1] : item.answer;
    return { '@type': 'Question', name: question, acceptedAnswer: { '@type': 'Answer', text: answer } };
  }) };
}
function routeSchemas(pathname) {
  pathname = pathname.replace(/\/+$/, "") || "/";
  const graphs = [breadcrumbSchema(pathname)];
  const pillar = content.servicePillars.find(def => '/' + def.slug === pathname);
  if (pillar) graphs.push(serviceSchema(pillar));
  if (pathname === '/core' || pathname === '/plans') {
    const plans = pathname === '/plans';
    graphs.push({ '@context': 'https://schema.org', '@type': 'SoftwareApplication',
      '@id': `${ORIGIN}${pathname}#software`, name: plans ? 'ForgedOps Plans' : 'ForgedOps Operations Platform',
      applicationCategory: 'BusinessApplication', operatingSystem: 'Web browser',
      description: seo.routes[pathname].description, url: plans ? content.plansUrl : `${ORIGIN}/core`,
      mainEntityOfPage: `${ORIGIN}${pathname}`, publisher: { '@id': ORG_ID } });
  }
  const page=servicePages[pathname];
  if(page){
    graphs.push(serviceSchema({name:page.name,description:page.summary,serviceType:page.name,url:ORIGIN+pathname,image:ORIGIN+page.image}));
    if(page.group==='training') graphs.push({'@context':'https://schema.org','@type':'Course',name:page.name,description:page.summary,url:ORIGIN+pathname,provider:{'@id':ORG_ID},teaches:page.topics});
  }
  if(pathname==='/products/basepoint') graphs.push({'@context':'https://schema.org','@type':'Product','@id':ORIGIN+pathname+'#product',name:'BASEPOINT GNSS Base-Station Post Mount',description:seo.routes[pathname].description,image:seo.routes[pathname].image,brand:{'@type':'Brand',name:'ForgedOps'},offers:{'@type':'Offer',url:'https://www.ebay.com/itm/960101007246',price:'329.99',priceCurrency:'USD',seller:{'@id':ORG_ID}}});
  const questions = content.faqs[pathname] || content.landingPages[pathname]?.faqs || page?.faqs;
  if (questions?.length) graphs.push(faqPageSchema(questions));
  return graphs;
}
function allSchemas(pathname) {
  return [organizationSchema(), websiteSchema(), localBusinessSchema(), ...routeSchemas(pathname)];
}
const SERVICE_PILLARS = content.servicePillars;
export { ORG, SERVICE_PILLARS, organizationSchema,
  websiteSchema, localBusinessSchema, serviceSchema, breadcrumbSchema, faqPageSchema, routeSchemas, allSchemas };

